import { CATEGORY_LABELS, MARKET_LABELS, type Category, type Market } from "@shared/schema/signal";
import type { CategoryFilter, MarketFilter } from "../lib";

const markets = Object.keys(MARKET_LABELS) as Market[];
const categories = Object.keys(CATEGORY_LABELS) as Category[];

export function SignalFilters({ market, category, onMarket, onCategory }: {
  market: MarketFilter;
  category: CategoryFilter;
  onMarket: (value: MarketFilter) => void;
  onCategory: (value: CategoryFilter) => void;
}) {
  return (
    <div className="filters" aria-label="信号筛选">
      <div className="filter-group">
        <span>市场</span>
        <div>
          <button type="button" className={market === "ALL" ? "is-active" : ""} onClick={() => onMarket("ALL")}>全部市场</button>
          {markets.map((item) => <button type="button" className={market === item ? "is-active" : ""} onClick={() => onMarket(item)} key={item}>{MARKET_LABELS[item]}</button>)}
        </div>
      </div>
      <div className="filter-group">
        <span>分类</span>
        <div>
          <button type="button" className={category === "ALL" ? "is-active" : ""} onClick={() => onCategory("ALL")}>全部</button>
          {categories.map((item) => <button type="button" className={category === item ? "is-active" : ""} onClick={() => onCategory(item)} key={item}>{CATEGORY_LABELS[item]}</button>)}
        </div>
      </div>
    </div>
  );
}
